export default {
  // 金钱格式化
  formatMoney: function formatMoney(value) {
    return accounting.formatMoney(value, '');
  },
  // 默认加载图片
  errorPic: function errorPic(value) {
    return value || require('@/assets/images/lost2.png');
  },
  // 日期格式化
  formatDate: function formatDate(value) {
    return moment(value).format('YYYY-MM-DD');
  },
  // 时间格式化
  formatTime: function formatTime(value) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss');
  },
  // 手机号码格式化(中间四位为****)
  formatTel: function formatTel(value) {
    if (value) {
      return value.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
    } else {
      return '';
    }
  },
  // 单位格式化
  formatUnit: function formatUnit(val, type) {
    return accounting.formatMoney(value, '', type);
  },
  formatMonthChinese: function formatMonthChinese(n) {
    // let arr = ["零","一","二","三","四","五","六","七","八","九","十","十一","十二"]
    return "".concat(n, "\u4E2A\u6708");
  }
};